import type { SerializableAuthUser } from '../../interfaces/authUser';

export function getUserGroups(user?: SerializableAuthUser | null): string[] {
    return user?.groups ?? [];
}
